var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoingToCourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#546FFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6933 18.6933C19.5933 18.7933 19.4666 18.84 19.34 18.84C19.2133 18.84 19.0866 18.7933 18.9866 18.6933L15.6866 15.3933L16.04 15.04L16.3933 14.6866L19.6933 17.9866C19.8866 18.18 19.8866 18.5 19.6933 18.6933Z",
    fill: "#546FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3133 12.1867L14.18 16.0534C14.44 16.3134 14.44 16.7334 14.18 16.9934L13.58 17.6C13.04 18.1334 12.1867 18.1334 11.6533 17.6L8.75999 14.7067C8.23332 14.18 8.23332 13.32 8.75999 12.7867L9.36666 12.18C9.62666 11.9267 10.0533 11.9267 10.3133 12.1867Z",
    fill: "#546FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3934 12.7934L15.8534 15.3267C15.5867 15.5934 15.16 15.5934 14.8934 15.3267L11.04 11.4734C10.7734 11.2067 10.7734 10.78 11.04 10.5134L13.58 7.97337C14.1067 7.4467 14.9667 7.4467 15.5 7.97337L18.3934 10.8667C18.92 11.4 18.92 12.2534 18.3934 12.7934Z",
    fill: "#546FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 20.5H7.33331C7.05998 20.5 6.83331 20.2733 6.83331 20C6.83331 19.7267 7.05998 19.5 7.33331 19.5H11.3333C11.6066 19.5 11.8333 19.7267 11.8333 20C11.8333 20.2733 11.6066 20.5 11.3333 20.5Z",
    fill: "#546FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingToCourt);
export default __webpack_public_path__ + "static/media/GoingToCourt.5e2879f790f791ef9dd8c7325d1e2580.svg";
export { ForwardRef as ReactComponent };